import { Injectable } from '@angular/core';
import { EventService } from './event.service'
import { EventRepetitionService } from './event-repetition.service'
import { Event } from '../model/event';
import { EventRepetition } from '../model/event-repetition'
import { Observable, forkJoin } from 'rxjs';
import { map } from 'rxjs/operators'

@Injectable({
  providedIn: 'root'
})
export class EventRepeaterService {

  constructor(private readonly eventService: EventService,
    private readonly eventRepetitionService: EventRepetitionService) { }

  getEvents(): Observable<Event[]> {
    return forkJoin([this.eventService.getEvents(), this.eventRepetitionService.getEventRepetitions()]).pipe(map(results => {
      let events = results[0];
      let eventRepetitions = results[1];
      let newEvents = [];
      events.forEach(event => {
        if (event.eventRepetitionId) {
          let eventRepetition: EventRepetition = eventRepetitions.find(repetition => repetition.eventRepetitionId === event.eventRepetitionId);
          for (let date = this.createDate(event.date); date.getTime() <= this.createDate(eventRepetition.endDate).getTime(); date.setDate(date.getDate() + eventRepetition.repetitionType)) {
            // clone event with new date
            let newEvent: Event = Object.assign(new Event(), event);
            newEvent.date = new Date(date);
            newEvent.cancelled = eventRepetition.exceptions.some(exception => newEvent.date.getTime() === this.createDate(exception).getTime());
            newEvents.push(newEvent);
          }
        } else {
          event.date = new Date(event.date);
          newEvents.push(event);
        }
      });
      return newEvents;
    }));
  }

  private createDate(dateString: Date) {
    let date = new Date(dateString);
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    date.setMilliseconds(0);
    return date;
  }
}
